import React from 'react'
import AddBilling from '../addEditAddress/AddBilling'
import styles from './profilebody.module.css';

const AddressTable = ({customer,handleEditClick,heading,addressData}) => {
    return (
        <>
            {addressData?.map((address) => (
                <div className={styles.address_box}>
                    <div className={styles.h3}>{heading} Address</div>
                    <div className={styles.address_deets}>
                        <p><strong>{address?.factoryUnits}</strong></p>
                        <p>{address?.streetAddress} , {address?.state}   , {address?.country}-{address?.zipCode}</p>
                        <p><strong>Email : </strong>{customer?.email}</p>
                        <p><strong>Phone : </strong>{customer?.phone}</p>
                    </div>
                    <button className={styles.editbtn} onClick={() => handleEditClick(address)}>Edit Address</button>
                    
                </div>
            ))
            }
        </>
    )
}

export default AddressTable